<!--Loader-->
<div *ngIf="isLoading" class="ui active inverted dimmer">
    <div class="ui loader"></div>
</div>

<!--Form-->
<form autocomplete="nope" #form="ngForm" class="app-grid">
    <!--Report Name-->
    <mat-form-field class="columns-5 small-columns-12">
        <mat-label>{{ 'reporting.custom-reports.reportName' | translate }}</mat-label>
        <input
            type="text"
            [(ngModel)]="reportName"
            name="name"
            #name="ngModel"
            placeholder="{{ 'reporting.custom-reports.egCustomReportTitle' | translate }}"
            required
            matInput
        />

        <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
    </mat-form-field>

    <!--Expansion Panels-->
    <div class="columns-10 small-columns-12 required-for">
        <mat-label>{{ 'reporting.custom-reports.selectColumns' | translate }}</mat-label>
        <app-checklist-accordion [entities]="allColumns"></app-checklist-accordion>
    </div>
</form>
